import { insights } from '../api-client/index';
import { useAsyncData } from './useAsyncData';
export function useInventoryInsights() {
    return useAsyncData(() => insights.inventoryStats(), [], 'Failed to load inventory insights');
}
export function useRefillInsights() {
    return useAsyncData(() => insights.refillStats(), [], 'Failed to load refill insights');
}
export function useChartData(bin) {
    return useAsyncData(() => insights.chartData(bin), [bin], 'Failed to load chart data');
}
